<template>
  <div style="display:flex;justify-content:center;align-items: center;flex-direction:column;height:100%;">
    <v-card class="mx-auto" style="max-width: 1000px; width: 100%; padding: 16px;" outlined>
      <v-list-item style="display:flex;flex-direction:column; margin-bottom: 8px;">
        <v-list-item-avatar style="margin:10px 10px -5px 0px" tile>
          <v-img :src="require('@/assets/favicon.svg')" style="width: 30px; height: 30px;" />
        </v-list-item-avatar>
        <v-list-item-content style="margin-bottom:-60px;">
          <v-img :src="require('@/assets/accumap_text.svg')" width="150px"/>
        </v-list-item-content>
      </v-list-item>
      <v-card-title class="text-h6 text-center justify-center">실험 분석 의뢰서</v-card-title>
      
      <v-card-text style="padding: 8px;">
        <!-- 기본 정보 입력란 -->
        <v-card-title class="d-flex justify-space-between align-center" style="margin-bottom: 8px;">
          <span style="font-size: 1rem; color: #111;">1. 기본 정보</span>
        </v-card-title>
        <v-form>
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="의뢰인"
                v-model="name"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="기관"
                v-model="company"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="연락처"
                v-model="phone"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-menu
                ref="orderDateMenu"
                v-model="orderDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.orderDate"
                    label="의뢰일"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.orderDate"
                  no-title
                  @input="orderDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.specialNote"
                label="특이사항"
                outlined
                dense
                rows="4"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <!-- Stepper -->
        <v-card-title class="d-flex justify-space-between align-center" style="margin-bottom: 8px;">
          <span style="font-size: 1rem; color: #111;">2. 고객 요구사항</span>
        </v-card-title>
        <v-stepper v-model="step" alt-labels>
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" :rules="[() => true]" step="1" v-if="true">
              Service & Application
            </v-stepper-step>
            <v-divider v-if="!isSpecialApplication"></v-divider>
            <v-stepper-step :complete="step > 2" :rules="[() => true]" step="2" v-if="!isSpecialApplication && !isWGSWESWMSWMTS">
              Origin & Specimen
            </v-stepper-step>
            <v-stepper-step :complete="step > 2" :rules="[() => true]" step="2" v-if="isWGSWESWMSWMTS">
              Origin
            </v-stepper-step>
            <v-divider v-if="form.application === 'Amplicon Sequencing'"></v-divider>
            <v-stepper-step :complete="step > 3" :rules="[() => true]" step="3" v-if="form.application === 'Amplicon Sequencing'">
              Target & Region
            </v-stepper-step>
            <v-divider v-if="!isSpecialApplication"></v-divider>
            <v-stepper-step :complete="step > (form.application === 'Amplicon Sequencing' ? 4 : 3)" :rules="[() => true]" :step="form.application === 'Amplicon Sequencing' ? 4 : 3" v-if="!isSpecialApplication">
              Sample Type
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > (form.application === 'Amplicon Sequencing' ? 5 : 4)" :rules="[() => true]" :step="form.application === 'Amplicon Sequencing' ? 5 : 4" v-if="!isSpecialApplication">
              Sequencing Configuration
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Step 1: Service & Application -->
            <v-stepper-content step="1">
              <v-form>
                <v-subheader>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        Service & Application
                        <v-icon class="align-middle" color="grey lighten-1" small>mdi-help-circle</v-icon>
                      </span>
                    </template>
                    <span>요청할 Service와 Application을 선택합니다.</span>
                  </v-tooltip>
                </v-subheader>
                <v-row>
                  <v-col cols="6">
                    <v-select
                      v-model="form.service"
                      :items="serviceOptions"
                      label="Select Service Type"
                      required
                      outlined
                      dense
                      menu-props="auto"
                      :error-messages="!form.service && hasAttemptedStep1 ? ['Service type is required'] : []"
                      @change="onServiceChange"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="form.application"
                      :items="currentApplicationOptions"
                      label="Select Application Type"
                      required
                      outlined
                      dense
                      menu-props="auto"
                      :error-messages="!form.application && hasAttemptedStep1 ? ['Application type is required'] : []"
                      @change="onApplicationChange"
                    />
                  </v-col>
                </v-row>

                <v-row class="mt-4">
                  <v-col cols="12" v-if="form.application && isSpecialApplication">
                    <v-textarea
                      v-model="form.inquiry"
                      label="문의 내용"
                      outlined
                      dense
                      rows="4"
                    ></v-textarea>
                    <v-btn
                      color="primary"
                      :style="{ width: '100%', marginTop: '16px' }"
                      :disabled="sending"
                      :loading="sending"
                      @click="sendInquiryEmail"
                    >
                      메일로 문의하기
                    </v-btn>
                  </v-col>
                  <v-col cols="6" v-else>
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="nextStep(1)"
                    >
                      다음
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 2: Origin & Sample Count -->
            <v-stepper-content step="2" v-if="!isSpecialApplication && !isWGSWESWMSWMTS">
              <v-form>
                <v-subheader class="mt-4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        Origin
                        <v-icon class="align-middle" color="grey lighten-1" small>mdi-help-circle</v-icon>
                      </span>
                    </template>
                    <span>검체가 수집된 출처와 형태를 지정합니다.</span>
                  </v-tooltip>
                </v-subheader>
                <v-select
                  v-model="form.origin"
                  :items="currentOriginOptions"
                  label="Select Origin"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.origin && hasAttemptedStep2 ? ['Origin is required'] : []"
                />
                <v-text-field
                  v-if="form.origin === 'Other'"
                  v-model="form.otherOrigin"
                  label="Specify Other Origin"
                  outlined
                  dense
                  :error-messages="form.origin === 'Other' && !form.otherOrigin && hasAttemptedStep2 ? ['Other origin is required'] : []"
                />

                <v-subheader class="mt-4">
                  Specimen
                </v-subheader>
                <v-select
                  v-model="form.selectedSpecimen"
                  :items="currentOptions"
                  item-text="label"
                  item-value="name"
                  label="Select Specimen"
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.selectedSpecimen && hasAttemptedStep2 ? ['Specimen is required'] : []"
                />
                <v-text-field
                  v-if="form.selectedSpecimen === 'Other'"
                  v-model="form.otherItemText"
                  label="Specify Other Specimen"
                  outlined
                  dense
                  :error-messages="form.selectedSpecimen === 'Other' && !form.otherItemText && hasAttemptedStep2 ? ['Other specimen is required'] : []"
                />
                <v-subheader class="mt-4">
                  검체 개수 입력
                </v-subheader>
                <v-text-field
                  v-model="form.sampleCount"
                  label="n="
                  type="number"
                  min="0"
                  outlined
                  dense
                  :error-messages="!form.sampleCount && hasAttemptedStep2 ? ['Count is required'] : []"
                />

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="step--"
                    >
                      이전
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="nextStep(2)"
                    >
                      다음
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 2: Origin & Sample Count -->
            <v-stepper-content step="2" v-if="isWGSWESWMSWMTS">
              <v-form>
                <v-subheader class="mt-4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        Origin
                        <v-icon class="align-middle" color="grey lighten-1" small>mdi-help-circle</v-icon>
                      </span>
                    </template>
                    <span>검체가 수집된 출처를 지정합니다.</span>
                  </v-tooltip>
                </v-subheader>
                <v-select
                  v-model="form.origin"
                  :items="currentOriginOptions"
                  label="Select Origin"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.origin && hasAttemptedStep2 ? ['Origin is required'] : []"
                />
                <v-text-field
                  v-if="form.origin === 'Other'"
                  v-model="form.otherOrigin"
                  label="Specify Other Origin"
                  outlined
                  dense
                  :error-messages="form.origin === 'Other' && !form.otherOrigin && hasAttemptedStep2 ? ['Other origin is required'] : []"
                />

                <v-subheader class="mt-4">
                  검체 개수 입력
                </v-subheader>
                <v-text-field
                  v-model="form.sampleCount"
                  label="Sample Count"
                  type="number"
                  min="0"
                  outlined
                  dense
                  :error-messages="!form.sampleCount && hasAttemptedStep2 ? ['Sample count is required'] : []"
                  style="width: 100%;"
                />

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="step--"
                    >
                      이전
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="nextStep(2)"
                    >
                      다음
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 3: Target & Region (Amplicon Sequencing만) -->
            <v-stepper-content step="3" v-if="form.application === 'Amplicon Sequencing'">
              <v-form>
                <v-subheader class="mt-4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        Target & Region
                        <v-icon class="align-middle" color="grey lighten-1" small>mdi-help-circle</v-icon>
                      </span>
                    </template>
                    <span>Target과 Region을 선택합니다.</span>
                  </v-tooltip>
                </v-subheader>
                <v-select
                  v-model="form.ngsTarget"
                  :items="['16S rRNA', '18S rRNA', 'ITS']"
                  label="Select Target"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.ngsTarget && hasAttemptedStep3 ? ['Target is required'] : []"
                  @change="onTargetChange"
                />
                <v-select
                  v-if="form.ngsTarget === '16S rRNA'"
                  v-model="form.ngsRegion"
                  :items="['V1-V2', 'V4', 'V1-V3', 'V4-V5', 'V3', 'V6-V8', 'V3-V4', 'V7-V9', 'V3-V5', 'Other']"
                  label="Select Region"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.ngsRegion && hasAttemptedStep3 ? ['Region is required'] : []"
                />
                <v-select
                  v-if="form.ngsTarget === '18S rRNA'"
                  v-model="form.ngsRegion"
                  :items="['V3V4', 'V4', 'V9', 'ITS1', 'ITS2', 'Other']"
                  label="Select Region"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.ngsRegion && hasAttemptedStep3 ? ['Region is required'] : []"
                />
                <v-select
                  v-if="form.ngsTarget === 'ITS'"
                  v-model="form.ngsRegion"
                  :items="['1', '2']"
                  label="Select Region"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.ngsRegion && hasAttemptedStep3 ? ['Region is required'] : []"
                />
                <v-text-field
                  v-if="form.ngsRegion === 'Other'"
                  v-model="form.otherNgsRegion"
                  label="Specify Other Region"
                  outlined
                  dense
                  :error-messages="form.ngsRegion === 'Other' && !form.otherNgsRegion && hasAttemptedStep3 ? ['Other region is required'] : []"
                />

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="step--"
                    >
                      이전
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="nextStep(3)"
                    >
                      다음
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 4 or 3: Sample Type -->
            <v-stepper-content :step="form.application === 'Amplicon Sequencing' ? 4 : 3" v-if="!isSpecialApplication">
              <v-form>
                <v-subheader class="mt-4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        Sample Type
                        <v-icon class="align-middle" color="grey lighten-1" small>mdi-help-circle</v-icon>
                      </span>
                    </template>
                    <span>샘플 유형을 선택합니다.</span>
                  </v-tooltip>
                </v-subheader>
                <v-select
                  v-model="form.sampleType"
                  :items="['Specimen', 'DNA', 'RNA', 'Other']"
                  label="Select Sample Type"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.sampleType && hasAttemptedStep4 ? ['Sample type is required'] : []"
                  @change="onSampleTypeChange"
                />
                <v-select
                  v-if="form.sampleType === 'Specimen' || form.sampleType === 'Other'"
                  v-model="form.additionalSampleType"
                  :items="['DNA', 'RNA']"
                  label="Select Additional Sample Type"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.additionalSampleType && hasAttemptedStep4 ? ['Additional sample type is required'] : []"
                />

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="step--"
                    >
                      이전
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="nextStep(form.application === 'Amplicon Sequencing' ? 4 : 3)"
                    >
                      다음
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 5: Sequencing Configuration -->
            <v-stepper-content :step="form.application === 'Amplicon Sequencing' ? 5 : 4" v-if="!isSpecialApplication">
              <v-form>
                <v-subheader class="mt-4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        Sequencing Configuration
                        <v-icon class="align-middle" color="grey lighten-1" small>mdi-help-circle</v-icon>
                      </span>
                    </template>
                    <span>Sequencing Configuration을 선택합니다.</span>
                  </v-tooltip>
                </v-subheader>
                <v-select
                  v-model="form.platform"
                  :items="['Illumina', 'Pacbio', 'Nanopore', 'Other']"
                  label="Select Platform"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.platform && hasAttemptedStep5 ? ['Platform is required'] : []"
                />
                <v-text-field
                  v-if="form.platform === 'Other'"
                  v-model="form.otherPlatform"
                  label="Specify Other Platform"
                  outlined
                  dense
                  :error-messages="form.platform === 'Other' && !form.otherPlatform && hasAttemptedStep5 ? ['Other platform is required'] : []"
                />

                <v-subheader class="mt-4">
                  Output
                </v-subheader>
                <v-select
                  v-model="form.output"
                  :items="form.application === 'Amplicon Sequencing' ? ['20,000 reads', '50,000 reads', '100,000 reads', 'Other'] : ['2 Gb', '6 Gb', '10 Gb', '30 Gb', '90 Gb', 'Other']"
                  label="Select Output"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.output && hasAttemptedStep5 ? ['Output is required'] : []"
                />
                <v-text-field
                  v-if="form.output === 'Other'"
                  v-model="form.otherOutput"
                  label="Specify Other Output"
                  outlined
                  dense
                  :error-messages="form.output === 'Other' && !form.otherOutput && hasAttemptedStep5 ? ['Other output is required'] : []"
                />

                <v-subheader class="mt-4">
                  Read Length
                </v-subheader>
                <v-select
                  v-model="form.readLength"
                  :items="['2 x 100 bp', '2 x 150 bp', '2 x 250 bp', '2 x 300 bp', 'Other']"
                  label="Select Read Length"
                  required
                  outlined
                  dense
                  menu-props="auto"
                  :error-messages="!form.readLength && hasAttemptedStep5 ? ['Read length is required'] : []"
                />
                <v-text-field
                  v-if="form.readLength === 'Other'"
                  v-model="form.otherReadLength"
                  label="Specify Other Read Length"
                  outlined
                  dense
                  :error-messages="form.readLength === 'Other' && !form.otherReadLength && hasAttemptedStep5 ? ['Other read length is required'] : []"
                />

                <v-row class="mt-4">
                  <v-col cols="6">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="step--"
                    >
                      이전
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      outlined
                      color="primary"
                      :style="{ width: '98%', borderColor: '#1565C0', whiteSpace: 'nowrap', padding: '0 8px' }"
                      @click="nextStep(form.application === 'Amplicon Sequencing' ? 5 : 4)"
                    >
                      다음
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <!-- 샘플 목록 -->
        <br>
        <br>
        <v-divider></v-divider>
        <br>
        <v-card-title>
          <span style="font-size: 1rem; color: #111;">3. 샘플목록</span>
        </v-card-title>
        <v-card-text style="">
          <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px;">
            <small class="grey--text" style="flex: 1; margin-right: 20px;">
              * Sample Name과 Group Name은 영문 대소문자(A-Z, a-z), 숫자(0-9), 하이픈(-)만 허용되며, 숫자로만 구성될 수 없고, Sample Name은 중복이 허용되지 않습니다.
            </small>
            <v-btn outlined color="red" @click="removeGridRow" style="margin-right: 10px;">
              <v-icon left>mdi-delete</v-icon> 선택삭제
            </v-btn>
            <v-btn outlined color="blue" @click="resetToCustomerRequirements">
              <v-icon left>mdi-restart</v-icon> 초기화
            </v-btn>
          </div>
          <v-row>
            <v-col cols="6">
              <grid
                ref="grid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :column-options="gridProps.columnOptions"
                :body-height="gridProps.bodyHeight"
                :page-options="gridProps.pageOptions"
              />
            </v-col>
            <v-col cols="6">
              <v-card outlined style="height: 340px; overflow-y: auto;">
                <v-card-title class="text-h6">의뢰 요약</v-card-title>
                <v-divider></v-divider>
                <v-list>
                  <v-row>
                    <v-col cols="6" v-if="form.service">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Service</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.service }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.application">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Application</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.application }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.origin">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Origin</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.origin === 'Other' ? form.otherOrigin : form.origin }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.selectedSpecimen">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Specimen</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.selectedSpecimen === 'Other' ? form.otherItemText : form.selectedSpecimen }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.ngsTarget">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Target</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.ngsTarget }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.ngsRegion">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Region</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.ngsRegion === 'Other' ? form.otherNgsRegion : form.ngsRegion }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.sampleType">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Sample Type</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.sampleType }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.platform">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Platform</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.platform === 'Other' ? form.otherPlatform : form.platform }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.output">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Output</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.output === 'Other' ? form.otherOutput : form.output }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="6" v-if="form.readLength">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="font-size: 12px;">Read Length</v-list-item-title>
                          <v-list-item-subtitle style="font-size: 12px;">{{ form.readLength === 'Other' ? form.otherReadLength : form.readLength }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- 접수하기 버튼 -->
        <v-row class="mt-4">
          <v-col class="text-right">
            <v-btn
              color="primary"
              :disabled="gridProps.data.length === 0 || loading"
              :loading="loading"
              @click="submitOrder"
            >
              접수하기
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackBar"
      timeout="3000"
    >
      {{ snackBarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackBar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import 'tui-grid/dist/tui-grid.css'
import { Grid } from '@toast-ui/vue-grid'
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

export default {
  components: {
    Grid,
  },
  name: "Inquiry",
  data() {
    return {
      step: 1,
      menu: false,
      orderDateMenu: false,
      hasAttemptedStep1: false,
      hasAttemptedStep2: false,
      hasAttemptedStep3: false,
      hasAttemptedStep4: false,
      hasAttemptedStep5: false,
      show: false,
      serviceOptions: [
        "NGS",
        "Data Analysis",
        "Customized-Service"
      ],
      applicationOptions: {
        "NGS": [
          "WGS",
          "WES",
          "mRNA Seq",
          "Total RNA Seq",
          "micro RNA Seq",
          "scRNA Seq",
          "WMS",
          "WMTS",
          "Amplicon Sequencing",
          "Seq-Only (raw data)"
        ],
        "Data Analysis": [
          "Statistics analysis",
          "NGS Basic",
          "NGS Special",
          "Other"
        ],
        "Customized-Service": [
          "핵산추출",
          "샘플 QC",
          "PCR",
          "RT‑qPCR",
          "Other"
        ]
      },
      specimenOptions: [
        { name: "Tissue", label: "Tissue" },
        { name: "Feces", label: "Feces" },
        { name: "Cell", label: "Cell" },
        { name: "Blood", label: "Blood" },
        { name: "Soil", label: "Soil" },
        { name: "Urine", label: "Urine" },
        { name: "SeaWater", label: "Sea water" },
        { name: "Skin", label: "Skin" },
        { name: "Filter", label: "Filter" },
        { name: "Vagina", label: "Vagina" },
        { name: "Water", label: "Water" },
        { name: "Buccal", label: "Buccal" },
        { name: "Sludge", label: "Sludge" },
        { name: "Saliva", label: "Saliva" },
        { name: "FFPE", label: "FFPE" },
        { name: "Other", label: "Other" },
      ],
      sampleTypeOptions: ["Specimen", "DNA", "RNA"],
      form: {
        service: null,
        application: null,
        origin: null,
        otherOrigin: "",
        inquiry: "",
        items: {},
        otherItemText: "",
        selectedSpecimen: null,
        specialNote: "",
        inquiry: "",
        platform: null,
        otherPlatform: "",
        output: null,
        otherOutput: "",
        readLength: null,
        otherReadLength: "",
        ngsTarget: null,
        ngsRegion: null,
        otherNgsRegion: "",
        sampleCount: null,
      },
      gridProps: {
        data: [],
        myTheme: {
          name: 'myTheme',
          value: {
            cell: {
              normal: {
                background: '#fff',
                border: '#e0e0e0',
                showVerticalBorder: false,
                showHorizontalBorder: true
              },
              header: {
                background: '#e0e0e0',
                border: '#e0e0e0'
              },
              selectedHeader: {
                background: '#e0e0e0'
              }
            }
          }
        },
        columns: [
          { 
            header: 'Sample Name', 
            name: 'sampleName', 
            editor: 'text', 
            validation: {
              required: true,
              regExp: /^[A-Za-z0-9-]+$/, // 영문 대소문자, 숫자, 하이픈 허용
              validator: (value) => {
                // 숫자로만 구성된 경우를 방지
                if (/^\d+$/.test(value)) {
                  return {
                    valid: false,
                    message: 'Sample Name은 숫자로만 구성될 수 없습니다.'
                  };
                }
                // 중복 검사
                const sampleNames = this.gridProps.data.map(sample => sample.sampleName);
                const isDuplicate = sampleNames.filter(name => name === value).length > 1;
                if (isDuplicate) {
                  return {
                    valid: false,
                    message: 'Sample Name이 중복되었습니다.'
                  };
                }
                return { valid: true };
              }
            }
          },
          { 
            header: 'Group Name', 
            name: 'groupName', 
            editor: 'text', 
            validation: {
              regExp: /^[A-Za-z0-9-]+$/, // 영문 대소문자, 숫자, 하이픈 허용
              validator: (value) => {
                // 숫자로만 구성된 경우를 방지
                if (/^\d+$/.test(value)) {
                  return {
                    valid: false,
                    message: 'Group Name은 숫자로만 구성될 수 없습니다.'
                  };
                }
                return { valid: true };
              }
            }
          }
        ],
        options: {
          rowHeaders: ['checkbox','rowNum'],
          bodyHeight: 300,
        },
        columnOptions: {
          resizable: true,
        },
        bodyHeight: 400,
        pageOptions: {
          useClient: true,
          type: 'scroll',
          perPage: 50
        },
      },
      microbiomeOptions: {
        Human: [
          { name: "Feces", label: "Feces" },
          { name: "Blood", label: "Blood" },
          { name: "Urine", label: "Urine" },
          { name: "Skin", label: "Skin" },
          { name: "Vagina", label: "Vagina" },
          { name: "Buccal", label: "Buccal" },
          { name: "Saliva", label: "Saliva" },
          { name: "Other", label: "Other" },
        ],
        Animal: [
          { name: "Feces", label: "Feces" },
          { name: "Blood", label: "Blood" },
          { name: "Urine", label: "Urine" },
          { name: "Skin", label: "Skin" },
          { name: "Vagina", label: "Vagina" },
          { name: "Buccal", label: "Buccal" },
          { name: "Saliva", label: "Saliva" },
          { name: "Other", label: "Other" },
        ],
        Plant: [
          { name: "Fruit", label: "Fruit" },
          { name: "Tissue", label: "Tissue" },
          { name: "Other", label: "Other" },
        ],
        Environment: [
          { name: "Soil", label: "Soil" },
          { name: "Sludge", label: "Sludge" },
          { name: "SeaWater", label: "Sea water" },
          { name: "Water", label: "Water" },
          { name: "Filter", label: "Filter" },
          { name: "Other", label: "Other" },
        ],
        Other: [
          { name: "Other", label: "Other" },
        ],
      },
      rnaOptions: {
        Human: [
          { name: "Tissue", label: "Tissue" },
          { name: "Cell", label: "Cell" },
          { name: "HumanDerivedMaterial", label: "Human-derived material" },
          { name: "Other", label: "Other" },
        ],
        Animal: [
          { name: "Tissue", label: "Tissue" },
          { name: "Cell", label: "Cell" },
          { name: "HumanDerivedMaterial", label: "Human-derived material" },
          { name: "Other", label: "Other" },
        ],
        Plant: [
          { name: "Tissue", label: "Tissue" },
          { name: "Cell", label: "Cell" },
          { name: "HumanDerivedMaterial", label: "Human-derived material" },
          { name: "Other", label: "Other" },
        ],
      },
      userData : {},
      company: '',
      company_id: '',
      name: '',
      email: '',
      phone: '',
      snackBar: false,
      snackBarMessage: '',
      loading: false,
      sending: false,
    };
  },
  mounted() {
    this.getUserData();
    this.resetForm();
    this.form.orderDate = new Date().toISOString().substr(0, 10);
    if (this.$refs.grid) {
      this.$refs.grid.invoke('resetData', this.gridProps.data);
    }
  },
  computed: {
    isSpecialApplication() {
      return this.form.service === "Data Analysis" || this.form.service === "Customized-Service" || this.form.application === "Seq-Only (raw data)";
    },
    isWGSWESWMSWMTS() {
      return ["WGS", "WES", "WMS", "WMTS"].includes(this.form.application);
    },
    currentApplicationOptions() {
      return this.applicationOptions[this.form.service] || [];
    },
    currentOriginOptions() {
      if (["WGS", "WMS"].includes(this.form.application)) {
        return ["Human", "Animal", "Microbe", "Plant", "Other"];
      } else if (["WES", "WMTS"].includes(this.form.application)) {
        return ["Human", "Animal", "Other"];
      } else if (["mRNA Seq", "Total RNA Seq", "micro RNA Seq", "scRNA Seq"].includes(this.form.application)) {
        return ["Human", "Animal", "Plant"];
      } else if (this.form.application === "Amplicon Sequencing") {
        return ["Human", "Animal", "Plant", "Environment", "Other"];
      }
      return [];
    },
    currentOptions() {
      if (["mRNA Seq", "Total RNA Seq", "micro RNA Seq", "scRNA Seq"].includes(this.form.application)) {
        if (["Human", "Animal", "Plant"].includes(this.form.origin)) {
          return [
            { name: "Tissue", label: "Tissue" },
            { name: "Cell", label: "Cell" },
            { name: "Other", label: "Other" },
          ];
        }
      } else if (this.form.application === "Amplicon Sequencing") {
        if (this.form.origin === "Human") {
          return [
            { name: "Feces", label: "Feces" },
            { name: "Blood", label: "Blood" },
            { name: "Urine", label: "Urine" },
            { name: "Tissue", label: "Tissue" },
            { name: "Vagina", label: "Vagina" },
            { name: "Buccal", label: "Buccal" },
            { name: "Saliva", label: "Saliva" },
            { name: "Skin", label: "Skin" },
            { name: "Other", label: "Other" },
          ];
        } else if (this.form.origin === "Animal") {
          return [
            { name: "Feces", label: "Feces" },
            { name: "Blood", label: "Blood" },
            { name: "Urine", label: "Urine" },
            { name: "Tissue", label: "Tissue" },
            { name: "Saliva", label: "Saliva" },
            { name: "Skin", label: "Skin" },
            { name: "Other", label: "Other" },
          ];
        } else if (this.form.origin === "Plant") {
          return [
            { name: "Fruit", label: "Fruit" },
            { name: "Tissue", label: "Tissue" },
            { name: "Other", label: "Other" },
          ];
        } else if (this.form.origin === "Environment") {
          return [
            { name: "Soil", label: "Soil" },
            { name: "Sludge", label: "Sludge" },
            { name: "Sea water", label: "Sea water" },
            { name: "Water", label: "Water" },
            { name: "Filter", label: "Filter" },
            { name: "Dust", label: "Dust" },
            { name: "Other", label: "Other" },
          ];
        } else if (this.form.origin === "Other") {
          return [
            { name: "Other", label: "Other" },
          ];
        }
      }
      return [];
    },
    filteredSampleCounts() {
      return this.form.sampleCount > 0 ? { [this.form.selectedSpecimen]: this.form.sampleCount } : {};
    },
  },
  methods: {
    async getUserData() {
      // const token = this.$store.getters.getAccessToken;
      const token = localStorage.accessToken;      
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);}).join(""));
      this.userData = JSON.parse(jsonPayload);
      console.log(this.userData);
      this.name = this.userData.userName;
      this.phone = this.userData.phone;
      this.email = this.userData.email;
      this.company = this.userData.companyName;
      this.company_id = this.userData.company_id;
      return;
    },
    
    onServiceChange() {
      this.form.application = null; // 서비스가 변경되면 Application 초기화
      this.form.origin = null; // 서비스 변경 시 Origin 초기화
      this.form.selectedSpecimen = null; // 서비스 변경 시 Specimen 초기화
    },
    onApplicationChange() {
      this.form.origin = null; // Application 변경 시 Origin 초기화
      this.form.selectedSpecimen = null; // Application 변경 시 Specimen 초기화
      if (this.isSpecialApplication) {
        this.form.inquiry = ''; // 문의 내용 초기화
      }
    },
    validateStep1() {
      return this.form.service && this.form.application;
    },
    validateStep2() {
      if (this.isWGSWESWMSWMTS) {
        return this.form.origin && this.form.sampleCount > 0;
      }
      return this.form.origin && this.form.selectedSpecimen && this.form.sampleCount > 0;
    },
    validateStep3() {
      return this.form.ngsTarget && this.form.ngsRegion && (this.form.ngsRegion !== 'Other' || this.form.otherNgsRegion);
    },
    validateStep4() {
      return this.form.sampleType && (this.form.sampleType !== 'Specimen' && this.form.sampleType !== 'Other' || this.form.additionalSampleType);
    },
    validateStep5() {
      return this.form.platform && (this.form.platform !== 'Other' || this.form.otherPlatform) &&
             this.form.output && (this.form.output !== 'Other' || this.form.otherOutput) &&
             this.form.readLength && (this.form.readLength !== 'Other' || this.form.otherReadLength);
    },
    nextStep(currentStep) {
      console.log(currentStep);
      console.log(this.step);
      console.log(this.form.application);
      if (currentStep === 1) {
        this.hasAttemptedStep1 = true;
        if (this.validateStep1()) {
          this.form.origin = null; // 다음 단계로 갈 때 Origin 초기화
          this.step++;
        }
      } else if (currentStep === 2 && !this.isSpecialApplication) {
        this.hasAttemptedStep2 = true;
        if (this.validateStep2()) {
          if (this.form.application === 'Amplicon Sequencing') {
            this.step++;
          } else {
            this.step = 3; // Amplicon Sequencing이 아닌 경우 Sample Type 단계로 이동
          }
        }
      } else if (currentStep === 3 && this.form.application === 'Amplicon Sequencing') {
        this.hasAttemptedStep3 = true;
        if (this.validateStep3()) {
          this.step++;
        }
      } else if (currentStep === (this.form.application === 'Amplicon Sequencing' ? 4 : 3)) {
        this.hasAttemptedStep4 = true;
        if (this.validateStep4()) {
          this.step++; // Sample Type 단계에서 다음 단계로 이동
        }
      } else if (currentStep === (this.form.application === 'Amplicon Sequencing' ? 5 : 4)) {
        this.hasAttemptedStep5 = true;
        if (this.validateStep5()) {
          console.log(1111);
          this.addTableRows(); // Platform, Output & Read Length 단계에서 테이블에 샘플 추가
          this.step = 6; // Amplicon Sequencing의 경우에도 마지막 단계에서 폼을 숨기도록 설정
        }
      }
      if (this.step >= 6) { // 최대 단계에 도달했을 때
        return; // 더 이상 진행하지 않음
      }
    },
    addTableRows() {
      const newSamples = [];
      if (this.isWGSWESWMSWMTS) {
        // WGS, WES, WMS, WMTS의 경우
        for (let i = 0; i < this.form.sampleCount; i++) {
          const newSample = {
            id: `sample-${i}-${Date.now()}`,
            sampleName: "",
            specimen: this.form.origin === "Other" ? `Other(${this.form.otherOrigin})` : this.form.origin,
            service: this.form.service,
            application: this.form.application,
            origin: this.form.origin === "Other" ? `Other(${this.form.otherOrigin})` : this.form.origin,
            sampleType: this.form.sampleType,
            platform: this.form.platform,
            otherPlatform: this.form.otherPlatform,
            output: this.form.output,
            otherOutput: this.form.otherOutput,
            readLength: this.form.readLength,
            otherReadLength: this.form.otherReadLength,
          };
          newSamples.push(newSample);
        }
      } else {
        // 기존 로직
        for (let i = 0; i < this.form.sampleCount; i++) {
          const newSample = {
            id: `${this.form.selectedSpecimen}-${i}-${Date.now()}`,
            sampleName: "",
            specimen: this.form.selectedSpecimen === "Other" ? `Other(${this.form.otherItemText})` : this.form.selectedSpecimen,
            service: this.form.service,
            application: this.form.application,
            origin: this.form.origin === "Other" ? `Other(${this.form.otherOrigin})` : this.form.origin,
            sampleType: this.form.sampleType,
            platform: this.form.platform,
            otherPlatform: this.form.otherPlatform,
            output: this.form.output,
            otherOutput: this.form.otherOutput,
            readLength: this.form.readLength,
            otherReadLength: this.form.otherReadLength,
          };
          newSamples.push(newSample);
        }
      }
      this.gridProps.data = [...this.gridProps.data, ...newSamples];
      newSamples.forEach(sample => {
        this.$refs.grid.invoke('appendRow', sample);
      });
    },
    async sendInquiryEmail() {
      if (this.sending) return;
      this.sending = true;
      try {
        const body = {
          email: this.email,
          userId: this.userData.userId,
          subject: `의뢰서: ${this.form.service} - ${this.form.application} ${this.company} ${this.name}`,
          content: `
            <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
              <h2 style="color: #4CAF50; text-align: center;">실험 분석 Application 의뢰서(AccuMap)</h2>
              <p style="text-align: center; font-size: 14px; color: #555;">아래는 실험 분석 Application 의뢰에 대한 상세 정보입니다.</p>
              <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>AccuMapID:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.userData.userId}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>의뢰인:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.name}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>기관:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.company}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>연락처:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.phone}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>의뢰일:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.form.orderDate}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Service:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.form.service}</td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Application:</strong></td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${this.form.application}</td>
                </tr>
              </table>
              <div style="margin-bottom: 20px;">
                <h3 style="color: #4CAF50;">특이사항</h3>
                <p style="background-color: #f9f9f9; padding: 10px; border-radius: 4px;">${this.form.specialNote}</p>
              </div>
              <div>
                <h3 style="color: #4CAF50;">문의내용</h3>
                <p style="background-color: #f9f9f9; padding: 10px; border-radius: 4px;">${this.form.inquiry}</p>
              </div>
            </div>
          `,
        };

        const response = await this.$axios.post(`${this.$apiHost}/contact/sendMail`, {
          body,
          status: 'inquiry',
        });

        if (response.data.success || response.data.message === 'Success') {
          this.snackBarMessage = '문의가 성공적으로 전송되었습니다.';
          this.snackBar = true;
          this.resetForm();
        } else {
          this.snackBarMessage = '문의 전송에 실패했습니다. 다시 시도해주세요.';
          this.snackBar = true;
        }
      } catch (error) {
        console.error(error);
        this.snackBarMessage = '문의 전송 중 오류가 발생했습니다.';
        this.snackBar = true;
      } finally {
        this.sending = false;
      }
    },
    resetForm() {
      this.form = {
        service: null,
        application: null,
        origin: null,
        otherOrigin: "",
        inquiry: "",
        items: {},
        otherItemText: "",
        selectedSpecimen: null,
        specialNote: "",
        inquiry: "",
        platform: null,
        otherPlatform: "",
        output: null,
        otherOutput: "",
        readLength: null,
        otherReadLength: "",
        ngsTarget: null,
        ngsRegion: null,
        otherNgsRegion: "",
        sampleCount: null,
      };
      this.step = 1;
      this.hasAttemptedStep1 = false;
      this.hasAttemptedStep2 = false;
      this.hasAttemptedStep3 = false;
      this.hasAttemptedStep4 = false;
      this.hasAttemptedStep5 = false;
    },
    appendGridRow(count) {
      for (let i = 0; i < count; i++) {
        this.$refs.grid.invoke('appendRow', { sampleName: '', specimen: '' });
      }
    },
    removeGridRow() {
      const selectedRows = this.$refs.grid.invoke('getCheckedRows');
      const selectedRowIds = selectedRows.map(row => row.id);

      // 데이터에서 선택된 행 제거
      this.gridProps.data = this.gridProps.data.filter(row => !selectedRowIds.includes(row.id));

      // 선택된 행 제거
      this.$refs.grid.invoke('removeCheckedRows');

      // 모든 체크 해제
      this.$refs.grid.invoke('uncheckAll');
    },
    excelDownload() {
      this.$refs.grid.invoke('export', 'excel', { fileName: 'samples', useFormattedValue: true });
    },
    async submitOrder() {
      this.loading = true;
      try {
        this.$refs.grid.invoke('blur');
        
        // 그리드 유효성 검사
        const isValid = this.$refs.grid.invoke('validate');
        if (!isValid) {
          this.snackBarMessage = `Sample Name의 유효성 검사를 통과하지 못했습니다.`;
          this.snackBar = true;
          return;
        }

        const gridData = this.$refs.grid.invoke('getData').map(sample => ({
          sampleName: sample.sampleName,
          groupName: sample.groupName,
        }));

        if (gridData.length > 0) {
          const sampleNames = gridData.map(sample => sample.sampleName);
          const duplicateNames = sampleNames.filter((name, index) => sampleNames.indexOf(name) !== index);

          if (duplicateNames.length > 0) {
            console.log("Duplicate sample names:", duplicateNames);
            this.snackBarMessage = `중복된 Sample Name이 있습니다.`;
            this.snackBar = true;
            return;
          }
          const formData = {
            userId: this.userData.userId,
            name: this.name,
            company: this.company,
            phone: this.phone,
            email: this.email,
            orderDate: this.form.orderDate,
            specialNote: this.form.specialNote,
            service: this.form.service,
            application: this.form.application,
            origin: this.form.origin,
            otherOrigin: this.form.otherOrigin,
            selectedSpecimen: this.form.selectedSpecimen,
            otherSpecimen: this.form.selectedSpecimen === "Other" ? this.form.otherItemText : "",
            sampleType: this.form.sampleType,
            platform: this.form.platform,
            otherPlatform: this.form.otherPlatform,
            output: this.form.output,
            otherOutput: this.form.otherOutput,
            readLength: this.form.readLength,
            otherReadLength: this.form.otherReadLength,
            ngsTarget: this.form.ngsTarget,
            ngsRegion: this.form.ngsRegion,
            otherNgsRegion: this.form.otherNgsRegion,
            samples: gridData,
            company_id: this.company_id,
          };

          const response = await this.$axios.post(`${this.$apiHost}/order/submit`, formData);
          console.log(response);
          if (response.data.message === 'Success') {
            this.snackBarMessage = '주문이 성공적으로 접수되었습니다.';
            this.snackBar = true;
            this.resetForm();
            this.gridProps.data = []; // 그리드 데이터 초기화
            this.$refs.grid.invoke('resetData', this.gridProps.data); // 그리드 초기화
          } else {
            this.snackBarMessage = '주문 접수에 실패했습니다. 다시 시도해주세요.';
            this.snackBar = true;
          }
        } else {
          console.log("No samples to submit.");
        }
      } catch (error) {
        console.error(error);
        this.snackBarMessage = '주문 접수 중 오류가 발생했습니다.';
        this.snackBar = true;
      } finally {
        this.loading = false;
      }
    },
    onTargetChange() {
      this.form.ngsRegion = null; // Target 변경 시 Region 초기화
      this.form.otherNgsRegion = ''; // Other Region 초기화
    },
    onSampleTypeChange() {
      this.form.additionalSampleType = null; // Sample Type 변경 시 추가 Sample Type 초기화
    },
    resetToCustomerRequirements() {
      // 모든 단계를 처음부터 다시 입력할 수 있도록 초기화
      this.step = 1; // 첫 번째 단계로 이동
      this.form.service = null;
      this.form.application = null;
      this.form.origin = null;
      this.form.selectedSpecimen = null;
      this.form.sampleType = null;
      this.form.platform = null;
      this.form.output = null;
      this.form.readLength = null;
      this.form.ngsTarget = null;
      this.form.ngsRegion = null;
      this.form.otherNgsRegion = "";
      this.form.sampleCount = null;
      this.gridProps.data = []; // 그리드 데이터 초기화
      this.$refs.grid.invoke('resetData', this.gridProps.data); // 그리드 초기화
      this.$refs.grid.invoke('uncheckAll'); // 모든 체크 해제
    },
  },
};
</script>

<style scoped>
/* 스타일을 여기에 추가 */
.v-card-title {
  font-size: 14px; /* 글꼴 크기 줄이기 */
}

.v-subheader {
  font-size: 12px; /* 글꼴 크기 줄이기 */
}

.v-btn {
  font-size: 14px; /* 버튼 글꼴 크기 */
  margin: 5px; /* 버튼 간격 */
}

.v-icon {
  margin-right: 5px; /* 아이콘과 텍스트 간격 */
}

.grey--text {
  font-size: 12px; /* 설명 글꼴 크기 */
  line-height: 1.5; /* 줄 간격 */
}

.v-card {
  border: 1px solid #E0E0E0; /* 테두리 색상 간소화 */
}

.v-container {
  padding: 8px; /* 패딩 줄이기 */
}

.red--text {
  color: #f44336; /* Vuetify의 red 색상 */
  font-size: 12px; /* 에러 메시지 글꼴 크기 */
}

.align-middle {
  vertical-align: middle;
}
</style>
